import { faker } from '@faker-js/faker'

import { Currency, Price } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getPrice = asBuilder((): Price => {
  const originalAmount = faker.number.int({ min: 100_000, max: 1_000_000 })
  const discountPercentage = faker.number.int({ min: 0, max: 9 }) * 10
  const discountedAmount = originalAmount * parseFloat((1 - discountPercentage / 100).toFixed(2))

  return {
    originalAmount,
    discountedAmount,
    discountPercentage,
    exchangeRateAppliedPrice: {
      currency: faker.helpers.enumValue(Currency),
      originalAmount: faker.number.int({ min: 100_000, max: 1_000_000 }),
      discountedAmount: faker.number.int({ min: 100_000, max: 1_000_000 }),
    },
    currency: faker.helpers.enumValue(Currency),
  }
})
